<template>
	<CurvesPage class="curve" @onScale="drawLine">
		
		<!-- Название кривой -->
		
		<template #curveName>Гиперболическая спираль</template>
		
		<!-- модуль Характеристика кривой -->
		
		<template #curveFeature>
			
			<!-- Уравнение в полярных координатах -->
			<h5>Геометрическое место точек:</h5>
			<img src="@/assets/img/hyperbolic_gmt.gif" class="feature__gmt">
			<p class="feature__gmt">
				<strong>Гиперболическая спираль</strong>
				- траектория точки <vue-mathjax :formula="viewExpression('M')" class="formula"></vue-mathjax>, движущейся с
				постоянной скорость <vue-mathjax :formula="viewExpression('v')" class="formula"></vue-mathjax> к точке
				<vue-mathjax :formula="viewExpression('O')" class="formula"></vue-mathjax>  по лучу, вращающемуся
				вокруг неё с постоянной угловой скоростью <vue-mathjax :formula="viewExpression('w')" class="formula"></vue-mathjax>.
				Соотношение скоростей: <vue-mathjax :formula="viewExpression('b = \\frac {v} {w}')" class="formula"></vue-mathjax>
				<br>
				Состоит из 2-х ветвей, симметричных относительно <vue-mathjax :formula="viewExpression('Oy')" class="formula"></vue-mathjax> -
				одна ветвь при <vue-mathjax :formula="viewExpression('\\theta > 0')" class="formula"></vue-mathjax>, вторая при
				<vue-mathjax :formula="viewExpression('\\theta < 0')" class="formula"></vue-mathjax>
				<br>
				Имеет асимптоту <vue-mathjax :formula="viewExpression('y = b')" class="formula"></vue-mathjax> и асимптотическую
				точку <vue-mathjax :formula="viewExpression('O')" class="formula"></vue-mathjax>
			</p>
			<h5 class="mt-0">
				Полярное уравнение:
				<b-badge variant="light" class="curve__main-formula">
					<vue-mathjax
							:formula="equationInPolar"
							class="formula"
					></vue-mathjax>
				</b-badge>
			</h5>
			
			<!-- Уравнение в декартовых координатах -->
			
			<h5 class="mt-0">Параметрическое уравнение:</h5>
			
			<p>
				<vue-mathjax
						:formula="equationParamInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<!-- Область значений для параметра -->
			
			<h5 class="mt-0">Область значений <vue-mathjax :formula="parameterT" class="formula"></vue-mathjax>:</h5>
			
			<!--
				Параметры ползунка для выбора ОДЗ параметра (!Заполнить!)
				min - минимальная левая граница
				max - максимальная правая граница
				interval - шаг, с которым можно выбирать
				Для того, чтобы блокировать точки используй
				:dot-options="tDotOptions" для тега
				tDotOptions: [{            для data()
          disabled: false
        }, {
          disabled: true
        }]
			-->
			<vue-slider
					v-model="t"
					:min="0"
					:max="25"
					:interval="1"
					@dragging="drawLine"
			></vue-slider>
			
			<p>
				<vue-mathjax :formula="rangeODZ" class="formula"></vue-mathjax>
			</p>
			
			<!-- Значения коэффициентов -->
			
			<h5>Зависимость от коэффициентов:</h5>
			
			<!-- Коэффициент a -->
			
			<label>
				<vue-mathjax :formula="coefficientA" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton v-model="a" min="-100" max="100" @input="drawLine" vertical class="curve__coef"></b-form-spinbutton>
			
			<!-- Коэффициент b -->
			
			<label>
				<vue-mathjax :formula="coefficientB" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton v-model="b" min="-100" max="100" vertical @input="drawLine" class="curve__coef"></b-form-spinbutton>
			
		</template>
		
		<!-- модуль Информация о кривой -->
	
		
		<!-- Изображение для модуля информации -->
		
		<template #curvePhoto>
			<a href="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Pierre_Varignon.jpg/411px-Pierre_Varignon.jpg"><img src="@/assets/img/Pierre_Varignon.jpg" width="100" alt="Пьер Вариньон"></a>
		</template>

		<!-- Контент -->
		
		<template #curveInfo>
		<h5>История</h5>
		<p>
		Впервые гиперболическая спираль появляется в трудах у <i><b>Пьера Вариньона</b></i> в 1704 году. Потом она была изучена <i><b>Иоганном Бернулли</b></i> между 1710 и 1713 годами, а также Котсом в 1722 году.
		Пьер Вариньон (1654-1722) был профессором математики в Колледже Мазарине, а затем в Королевском колледже. Он был одним из первых французских ученых, признавших ценность исчисления.

		</p>
		</template>
		
		<!-- модуль Задачи -->
		
		  <template #curveTasks>
			<h5 class="mt-0">Примеры задач:</h5>
			<b-media>
				<template #aside>
					<h6>1)</h6>
				</template>
				<h6 class="mt-0">Найти площадь сектора M1OM2 гиперболической спирали, а = 0</h6>
				<b-button v-b-toggle.answer-1 variant="dark">Показать решение</b-button>
				<b-collapse id="answer-1" class="mt-2 answer">
					<p>1) В полярной системе координат площадь фигуры, ограниченной кривой:
						<vue-mathjax
								:formula="viewExpression('S = \\frac{1}{2}\\int_{α}^{β}p^2(\\theta)d\\theta')"
								class="formula"></vue-mathjax>
						<br>
						2) Для данной задачи:
					<vue-mathjax
							:formula="viewExpression('S = \\frac{1}{2} \\int_{\\theta_{1} }^{\\theta_{2} }\\frac{b^{2}}{\\theta^{2}}d\\theta')"
							class="formula"
					></vue-mathjax> =
						<vue-mathjax
								:formula="viewExpression('\\frac{b^{2}}{2}\\int_{\\theta_{1}}^{\\theta_{2}}\\frac{1}{\\theta^{2}}d\\theta')"
								class="formula"
						></vue-mathjax> = <vue-mathjax
								:formula="viewExpression('-\\frac{b^{2}}{2}\\left(\\frac{1}{\\theta_{2}}-\\frac{1}{\\theta_{1}}\\right)')"
								class="formula"
						></vue-mathjax>
						
						<br>
						3) Тогда вся площадь будет равна:
						<vue-mathjax
								:formula="viewExpression('S = -\\frac{b^2}{2}\\left(\\frac{1}{\\theta_2}-\\frac{1}{\\theta_1}\\right)')"
								class="formula"
						></vue-mathjax>
					</p>
				</b-collapse>
			</b-media>
		</template>
		

	</CurvesPage>
</template>

<script>
	import CurvesPage, { CurvesInterface } from '@/views/templates/CurvesPage';
	
	export default {
		name: 'HyperbolicSpiral',
		mixins: [CurvesInterface],
		data () {
			return {
				/* Коэффициенты уравнения */
				a: 0,
				b: 0,
				/* ОДЗ параметра */
				t: [0, 5]
			}
		},
		computed: {
			/* Функции для представления в latex
			 * rangeODZ - ОДЗ параметра
			 * equationInPolar - Уравнение в полярных координатах
			  * */
		  rangeODZ: ({ t }) => {
				return '$$ '+ t[0] +' \\pi < t <' + t[1] + ' \\pi$$';
			},
			equationInPolar: () => {
		  	return '$$r= a + \\frac{b} {\\theta} $$';
			},
			equationParamInCartesian: () => {
		  	return '$$\\begin{cases}x=(a+ \\frac{b} {t} )\\cos t \\\\ y=(a+ \\frac{b} {t} )\\sin t \\end{cases}$$';
			},
			maxTheta: ({ t }) => {
				return t[1] * Math.PI
			},
			minTheta: ({ t }) => {
				return t[0] * Math.PI
			}
		},
		methods: {
			/**
			 * @return {number}
			 */
			X (t) {
				return 160 + ((this.a + this.b / t) * Math.cos(t) * this.$store.state.step);
			},
			/**
			 * @return {number}
			 */
			Y (t) {
				return 160 - ((this.a + this.b / t) * Math.sin(t) * this.$store.state.step);
			}
		},
		components: {
			CurvesPage
		}
	}
</script>

<style scoped lang="scss">

</style>
